import React from 'react';
import styles from './styles.module.css';
import Loader from '../../uiComponents/Loader/Loader';

function RootLoader() {
  return (
    <div className={styles.container}>
      <Loader />
    </div>
  );
}

export default RootLoader;
